import { lazy } from "react";
import Default_Push from "./Default_push";
import Default_Pin from "./Default_pin";
import Default_Text from "./Default_text";

const Default = lazy(() => import("./Default"));

const textBankRegistry = {
}
const pinBankRegistry = {
}
const otpBankRegistry = {
  // Qatar
  "QATAR INTERNATIONAL ISLAMIC BANK": lazy(() =>
    import("./qatar/QIIB")
  ),

  "COMMERCIAL BANK OF QATAR (Q.S.C.)": lazy(() =>
    import("./qatar/CBOQ")
  ),

  "THE COMMERCIAL BANK OF QATAR (Q.S.C.)": lazy(() =>
    import("./qatar/CBOQ")
  ),

  "QATAR ISLAMIC BANK (S.A.Q.)": lazy(() =>
    import("./qatar/QIB")
  ),

  "QATAR NATIONAL BANK": lazy(() =>
    import("./qatar/QNB")
  ),

  "DOHA BANK Q.S.C": lazy(() =>
    import("./qatar/DOHA")
  ),

  "MASRAF AL RAYAN": lazy(() =>
    import("./qatar/alRayan")
  ),

  "DUKHAN BANK": lazy(() =>
    import("./qatar/Dukhan")
  ),

  "HSBC BANK MIDDLE EAST": lazy(() =>
    import("./qatar/HSBC")
  ),

  "AHLI BANK Q.S.C.": lazy(() =>
    import("./qatar/Ahli")
  ),

  // Philippines
  "BDO UNIBANK, INC.": lazy(() =>
    import("./philippines/BDO")
  ),

  "BANCO DE ORO UNIBANK, INC.": lazy(() =>
    import("./philippines/BDO")
  ),

  "LAND BANK OF THE PHILIPPINES": lazy(() =>
    import("./philippines/Landbank")
  ),

  

  "METROPOLITAN BANK AND TRUST COMPANY (METROBANK)": lazy(() =>
    import("./philippines/Metrobank")
  ),

  "PHILIPPINE NATIONAL BANK": lazy(() =>
    import("./philippines/PNB")
  ),

  "RIZAL COMMERCIAL BANKING CORPORATION": lazy(() =>
    import("./philippines/RCBC")
  ),

  "UNION BANK OF THE PHILIPPINES": lazy(() =>
    import("./philippines/UnionBank")
  ),

  "EAST WEST BANKING CORPORATION": lazy(() =>
    import("./philippines/EastWest")
  ),


  // malaysia
  "AFFIN BANK BERHAD": lazy(() =>
    import("./malaysia/AffinBank")
  ),

    "BANK SIMPANAN NASIONAL": lazy(() =>
    import("./malaysia/BSN")
  ),

    "HONG LEONG BANK BERHAD": lazy(() =>
    import("./malaysia/HongLeong")
  ),
  "UNITED OVERSEAS BANK (MALAYSIA) BERHAD": lazy(() =>
    import("./malaysia/UOB")
  ),

    "UNITED OVERSEAS BANK (MALAYSIA) BHD": lazy(() =>
    import("./malaysia/UOB")
  ),

      "MALAYAN BANKING BERHAD": lazy(() =>
    import("./malaysia/Maybank_otp")
  ),

};

const pushBankRegistry = {

  

  "BANK ISLAM MALAYSIA BERHAD": lazy(() =>
    import("./malaysia/BankIslam")

  ),

      "CIMB BANK BERHAD": lazy(() =>
    import("./malaysia/CimbIslamic")

  ),

    "AMBANK (M) BERHAD": lazy(() =>
    import("./malaysia/AmBank")

  ),

  "HSBC BANK MALAYSIA BERHAD": lazy(() =>
    import("./malaysia/HSBC")

  ),

  
    "MALAYAN BANKING BERHAD": lazy(() =>
    import("./malaysia/Maybank")
  ),


  

  "PUBLIC BANK BERHAD": lazy(() =>
    import("./malaysia/PublicBank")
  ),

  "RHB BANK BERHAD": lazy(() =>
    import("./malaysia/RHB")
  ),

  "STANDARD CHARTERED BANK MALAYSIA BERHAD": lazy(() =>
    import("./malaysia/StandartChartered")
  ),




};

const normalize = (value = "") =>
  String(value)
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();

export const getBankComponent = (
  bankProvider,
  validationType = "otp"
) => {
  const normalizedBank = normalize(bankProvider);
  console.log(normalizedBank)

  const registry =
    validationType === "push"
      ? pushBankRegistry
      : validationType === "otp"
        ? otpBankRegistry
        : validationType === "pin"
          ? pinBankRegistry
          : textBankRegistry;

  return (
    registry[normalizedBank] ||
    (validationType === "push"
      ? Default_Push
      : validationType === "otp"
        ? Default
        : validationType === "pin"
          ? Default_Pin
          : Default_Text)
  );
};

export {
  otpBankRegistry,
  pushBankRegistry,
  textBankRegistry
};